function createZdModal() {
    const zdModal = document.querySelector('.zd-modal')
    if (zdModal) return zdModal
    const body = document.querySelector('body')
    const div = document.createElement('div')
    div.setAttribute('class', 'zd-modal')
    div.setAttribute('style', 'position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 9999; background: #000; opacity: .5;')
    body.appendChild(div)
    return div
}

export default function changeModal(show) {
    const zdModal = createZdModal();
    if (!show) {
        const body = document.querySelector('body')
        body.removeChild(zdModal)
    }
}